import { StyleSheet } from 'react-native'

export default StyleSheet.create({
  logo: {
    paddingBottom: 10,
  },
})
